import { $, $$ } from '@3pc/dom';

// Because of the navigation.js. Darkmode gets cloned, thats why we need to use an array.
// So if you copy the code, you might have to refactor!
export default class Toggle {
  constructor(props) {
    this.container = props.container;
    this.checkbox = props.checkbox;
    this.cookieName = 'Social-Media-Toggle';
    this.cookieDuration = 36500;
    this.checked = false;
    this.iframesInitted = false;
  }

  checkCookie = cookieName => {
    const nameEQ = `${cookieName}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  createCookie = () => {
    let expires = '';
    const days = this.cookieDuration;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }

    document.cookie = `${this.cookieName}=${this.checked}${expires}; path=/; samesite=strict`;
  };

  toggleClasses = () => {
    this.checkbox.parentElement.classList.toggle('is-active');
    if (this.checkbox.checked) {
      this.checked = true;
    } else {
      this.checked = false;
      window.location.reload();
    }
  };

  toggleSocialmedias = () => {
    const socialmedias = $$('iframe, script', this.container);

    if (!this.container.classList.contains('is-active')) {
      this.container.classList.add('is-active');
      if (!this.iframesInitted) {
        socialmedias.forEach(socialmedia => {
          if (socialmedia.dataset.src) {
            socialmedia.setAttribute('src', socialmedia.dataset.src);
          }
        });
        this.iframesInitted = true;
      }
    } else {
      this.container.classList.remove('is-active');
    }
  };

  init = () => {
    // check if cookie exists (with the users choice to use toggle or not)
    if (
      document.cookie.indexOf(this.cookieName) > 0 &&
      this.checkCookie(this.cookieName) === 'true'
    ) {
      this.checkbox.checked = true;
      this.checked = true;
      this.toggleClasses();
      this.toggleSocialmedias();
    } else {
      this.checkbox.checked = false;
      this.checked = false;
    }

    this.checkbox.addEventListener('click', () => {
      this.toggleSocialmedias();
      this.toggleClasses();
      this.createCookie();
    });
  };
}

const socialmedias = $$('.socialmedia');
socialmedias.length &&
  socialmedias.forEach(socialmedia => {
    const checkbox = $('input[type="checkbox"]', socialmedia);
    new Toggle({
      container: socialmedia,
      checkbox,
    }).init();
  });

const socialmediaTeasers = $$('.socialmedia-teaser');
socialmediaTeasers.length &&
  socialmediaTeasers.forEach(socialmediaTeaser => {
    const checkbox = $('input[type="checkbox"]', socialmediaTeaser);
    new Toggle({
      container: socialmediaTeaser,
      checkbox,
    }).init();
  });
